export default __webpack_public_path__ + "static/media/330_business02-es-web.f7db1db6.png";